export default "__VITE_ASSET__DNmTPbBk__"